import "./Transfer.scss";
import CustomerMyOrder from "../../CustomerMyOrder";

const TransferOrder = () => <CustomerMyOrder />;

export default TransferOrder;
